import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import ContactSection from "../../components/common/ContactSection";
import { Check } from "lucide-react";
import ResearchSection from "./ResearchSection";
import ProcurementOptions from "../../components/common/ProcurementOptions";

const CentralLabTesting = () => {
  const [expandedItems, setExpandedItems] = useState({});

  const toggleExpanded = (index) => {
    setExpandedItems((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const customData2 = [
    {
      title: "RNA/DNA Extraction",
      description:
        "High-yield extraction from diverse biospecimens including FFPE, whole blood, and stabilized saliva.",
    },
    {
      title: "Molecular Services",
      description:
        "Quantitative PCR (qPCR), digital droplet PCR, and custom assay design for targeted detection.",
    },
    {
      title: "Genomic Analysis",
      description:
        "Next-Generation Sequencing (NGS) platforms for whole exome, transcriptome, and targeted panels.",
    },
    {
      title: "IHC & FISH",
      description:
        "Advanced staining and molecular cytogenetics for protein expression and chromosomal analysis.",
    },
    {
      title: "Histopathology",
      description:
        "Expert tissue processing, embedding, and sectioning with board-certified pathologist review.",
    },
    {
      title: "Method Validation",
      description:
        "Side-by-side comparison studies and analytical validation of your proprietary research assays.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>ANVIYA Biospecimen Services</title>
      </Helmet>

      <main className="w-full bg-white">
        <Header />
        <ResearchSection />
        <ProcurementOptions
          title="What We can Test"
          descriptionTitle=""
          options={customData2}
          icon={Check} // Optional: Changes the icon for all cards
        />
        {/* <SampleAccountability /> */}
        <ContactSection />
        <Footer />
      </main>
    </>
  );
};

export default CentralLabTesting;
